import { IReturnReasonPreset } from "../../policy-types";


class ReturnReasonsPreset {
    private _model: IReturnReasonPreset[] = [] as IReturnReasonPreset[];

    constructor(model: IReturnReasonPreset[]) {
        this._model = model;
    } 

    public get reasonsList(): IReturnReasonPreset[] {
        return this._model;
    }

    public getPresetById(merchantResolutionId: number): IReturnReasonPreset|undefined {
        return this.reasonsList.find(r => r.id === merchantResolutionId);
    }
}

export default ReturnReasonsPreset;
